import { DadosGraficoEmpregados, IStatePainelSolicitacoesDeHorasExtras, TipoHierarquia } from "./painelSolicitacoesDeHorasExtras.interface";
import { ID } from "@/tipos";

const stateResetada = (): IStatePainelSolicitacoesDeHorasExtras => ({
  carregandoFiltros: false,
  estaBuscandoDados: false,
  estaBuscandoDadosGraficoEmpregados: false,
  realizouPrimeiraBusca: false,
  idLocalDeTrabalhoGraficoEmpregados: null,
  filtros: {
    empregadoresSelecionados: [],
    gruposSelecionados: [],
    locaisTrabalhoSelecionados: [],
    usuariosLideresSelecionados: [],
    tipoHierarquiaSelecionada: null,
    dataInicial: null,
    dataFinal: null,
  },
  placar: {
    quantidadeTotalDeSolicitacoes: 0,
    aprovadas: {
      consolidado: '',
      quantidadeTotalSolicitacoesAprovadas: 0,
      quantidadeHorasAprovadas: '',
      quantidadeHorasJustificadasPosteriormente: '',
      quantidadeHorasSolicitadasAntecipadamente: '',
      quantidadeJustificativasPosteriores: 0,
      quantidadeSolicitacoesAntecipadas: 0,
    },
    pendentes: {
      consolidado: '',
      quantidadeTotalSolicitacoesPendentes: 0,
      quantidadeHorasJustificadasPosteriormenteAindaPendentes: '',
      quantidadeHorasPendentesDeJustificativa: '',
      quantidadeHorasSolicitadasAntecipadamenteAindaPendentes: '',
      quantidadeJustificativasPendentes: 0,
      quantidadeJustificativasPosterioresAindaPendentesDeResposta: 0,
      quantidadeSolicitacoesAindaPendentes: 0,
    },
    reprovadas: {
      consolidado: '',
      quantidadeTotalSolicitacoesReprovadas: 0,
      quantidadeHorasJustificadasPosteriormente: '',
      quantidadeHorasReprovadas: '',
      quantidadeHorasSolicitadasAntecipadamente: '',
      quantidadeJustificativasPosteriores: 0,
      quantidadeSolicitacoesAntecipadas: 0,
    },
    vencidas: {
      consolidado: '',
      quantidadeTotalDeSolicitacoesVencidas: 0,
      quantidadeDeHorasVencidasDeJustificativa: '',
      quantidadeDeHorasVencidasDeResposta: '',
      quantidadeSolicitacoesVencidasDeJustificativa: 0,
      quantidadeSolicitacoesVencidasDeResposta: 0,
    }
  },
  placarComDadosEmSegundos: {
    aprovadas: {
      consolidado: 0,
      quantidade_de_horas_aprovadas: 0,
      quantidade_de_horas_justificadas_posteriormente: 0,
      quantidade_de_horas_pre_aprovadas: 0,
      quantidade_de_horas_solicitadas_antecipadamente: 0,
      quantidade_de_justificativas_posteriores: 0,
      quantidade_de_solicitacoes_antecipadas: 0,
      quantidade_total_de_solicitacoes_aprovadas: 0,
      quantidade_total_de_solicitacoes_pre_aprovadas: 0,
    },
    pendentes: {
      consolidado: 0,
      quantidade_de_horas_justificadas_posteriormente_ainda_pendentes: 0,
      quantidade_de_horas_pendentes_de_justificativa: 0,
      quantidade_de_horas_solicitadas_antecipadamente_ainda_pendentes: 0,
      quantidade_de_justificativas_pendentes: 0,
      quantidade_de_justificativas_posteriores_ainda_pendentes_de_resposta: 0,
      quantidade_de_solicitacoes_ainda_pendentes: 0,
      quantidade_total_de_solicitacoes_pendentes: 0
    },
    ids: [],
    quantidade_total_de_solicitacoes: 0,
    reprovadas: {
      consolidado: 0,
      quantidade_de_horas_justificadas_posteriormente: 0,
      quantidade_de_horas_reprovadas: 0,
      quantidade_de_horas_solicitadas_antecipadamente: 0,
      quantidade_de_justificativas_posteriores: 0,
      quantidade_de_solicitacoes_antecipadas: 0,
      quantidade_total_de_solicitacoes_reprovadas: 0
    },
    vencidas: {
      consolidado: 0,
      quantidade_de_horas_vencidas_de_justificativa: 0,
      quantidade_de_horas_vencidas_de_resposta: 0,
      quantidade_solicitacoes_vencidas_de_justificativa: 0,
      quantidade_solicitacoes_vencidas_de_resposta: 0,
      quantidade_total_de_solicitacoes_vencidas: 0
    }
  },
  detalhesPorEmpregado: {},
})

const mutations = {
  definirCarregamentoFiltros(state: IStatePainelSolicitacoesDeHorasExtras, carregandoFiltros: boolean) {
    state.carregandoFiltros = carregandoFiltros;
  },
  definirEstaBuscandoDados(state: IStatePainelSolicitacoesDeHorasExtras, estaBuscandoDados: boolean) {
    state.estaBuscandoDados = estaBuscandoDados;
  },
  definirEstaBuscandoDadosGraficoEmpregados(state: IStatePainelSolicitacoesDeHorasExtras, estaBuscandoDadosGraficoEmpregados: boolean) {
    state.estaBuscandoDadosGraficoEmpregados = estaBuscandoDadosGraficoEmpregados;
  },
  definirRealizouPrimeiraBusca(state: IStatePainelSolicitacoesDeHorasExtras, realizouPrimeiraBusca: boolean) {
    state.realizouPrimeiraBusca = realizouPrimeiraBusca;
  },
  definirIdLocalDeTrabalhoGraficoEmpregados(state: IStatePainelSolicitacoesDeHorasExtras, idLocalDeTrabalhoGraficoEmpregados: ID | null) {
    state.idLocalDeTrabalhoGraficoEmpregados = idLocalDeTrabalhoGraficoEmpregados;
  },
  definirEmpregadoresSelecionados(state: IStatePainelSolicitacoesDeHorasExtras, empregadoresSelecionados: any) {
    state.filtros.empregadoresSelecionados = empregadoresSelecionados
  },
  definirGruposSelecionados(state: IStatePainelSolicitacoesDeHorasExtras, gruposSelecionados: any) {
    state.filtros.gruposSelecionados = gruposSelecionados
  },
  definirLocaisTrabalhoSelecionados(state: IStatePainelSolicitacoesDeHorasExtras, locaisTrabalhoSelecionados: any) {
    state.filtros.locaisTrabalhoSelecionados = locaisTrabalhoSelecionados
  },
  definirUsuariosLideresSelecionados(state: IStatePainelSolicitacoesDeHorasExtras, usuariosLideresSelecionados: any) {
    state.filtros.usuariosLideresSelecionados = usuariosLideresSelecionados
  },
  definirTipoHierarquiaSelecionada(state: IStatePainelSolicitacoesDeHorasExtras, tipoHierarquiaSelecionada: TipoHierarquia) {
    state.filtros.tipoHierarquiaSelecionada = tipoHierarquiaSelecionada;
  },
  definirDataInicial(state: IStatePainelSolicitacoesDeHorasExtras, dataInicial: Date) {
    state.filtros.dataInicial = dataInicial;
  },
  definirDataFinal(state: IStatePainelSolicitacoesDeHorasExtras, dataFinal: Date) {
    state.filtros.dataFinal = dataFinal;
  },
  definirPlacarComDadosEmSegundos(state: IStatePainelSolicitacoesDeHorasExtras, placarComDadosEmSegundos: IStatePainelSolicitacoesDeHorasExtras['placarComDadosEmSegundos']) {
    state.placarComDadosEmSegundos = placarComDadosEmSegundos;
  },
  definirPlacar(state: IStatePainelSolicitacoesDeHorasExtras, placar: IStatePainelSolicitacoesDeHorasExtras['placar']) {
    state.placar = placar;
  },
  definirGraficoEmpregadosPorLocalDeTrabalho(state: IStatePainelSolicitacoesDeHorasExtras, dados: { idLocalDeTrabalho: ID, placar: Array<DadosGraficoEmpregados> }) {
    dados.placar.forEach((item: DadosGraficoEmpregados) => {
      state.detalhesPorEmpregado[item.id] = item;
    })
  },
  definirTodosOsFiltros(state: IStatePainelSolicitacoesDeHorasExtras, filtros: IStatePainelSolicitacoesDeHorasExtras['filtros']) {
    state.filtros = filtros;
  },
  limparDadosDaApi(state: IStatePainelSolicitacoesDeHorasExtras) {
    state.placar = stateResetada().placar;
    state.detalhesPorEmpregado = stateResetada().detalhesPorEmpregado;
  },
  destruirState(state: IStatePainelSolicitacoesDeHorasExtras) {
    Object.assign(state, stateResetada());
  }
};

const actions = {
};

export default {
  namespaced: true,
  state: stateResetada(),
  mutations,
  actions,
};
